// @flow

// Action Types
const actionPrefix: string = '@@datatable/soil-job/'
export const SELECT_RECORDS = `${actionPrefix}SELECT_RECORDS`
export const UPDATE_FILTER = `${actionPrefix}UPDATE_FILTER`

export const NOT_PAID = 'Not Paid'

export const UNIT_ABRV_HECTARES = 'ha'
export const UNIT_ABRV_ACRES = 'ac'
export const NONE = 'none'
export const MULTI_GRID = 'multi'

// Datatable
export const DATATABLE_NAME = 'SoilJobs'

// Record attrs
export const ATTR_SOIL_JOB_ID = 'id'
export const ATTR_CREATED_DATE = 'created_date'
export const ATTR_SEASON = 'season'
export const ATTR_FARM = 'farm'
export const ATTR_FIELD = 'field'
export const ATTR_GRID_SIZE = 'grid_size'
export const ATTR_AREA = 'area'
export const ATTR_PRICE = 'price'
export const ATTR_STATUS = 'status'
export const ATTR_PAID = 'paid'
export const ATTR_MAP_VIEW = 'map_view'
export const ATTR_LAB_RESULTS = 'lab_results'
export const ATTR_COMMENTS = 'comments'
export const ATTR_RECOMMENDATIONS = 'recommendations'
export const ATTR_REOPEN_JOB = 'reopenJob'
export const ATTR_HAS_MAP_VIEW = 'hasMapView'
export const ATTR_HAS_LAB_RESULTS = 'hasLabResults'
export const ATTR_HAS_COMMENTS = 'hasComments'
export const ATTR_HAS_RECOMMENDATIONS = 'hasRecommendations'
export const ATTR_HAS_REOPEN_JOB_BTN = 'hasReopenJobBtn'
